export default __webpack_public_path__ + "static/media/ok_icon.717f4572.svg";